var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable, override } from 'mobx';
import { QuestionScore } from '../../../classes/question/modules/QuestionScore';
export class MultiSelectScore extends QuestionScore {
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get question() {
        return this.parent;
    }
    get maxPoints() {
        return this.question.tasks.length;
    }
    get reachedPoints() {
        return this.question.tasks.filter(task => task.taskEval.isCorrectlySelected).length;
    }
    get progressiveReachablePoints() {
        return this.question.tasks.filter(task => task.taskEval.isComplete).length;
    }
    get shouldSetCompletedTimestamp() {
        if (!this.question.answer)
            return false;
        return this.question.tasks.filter(task => !task.taskEval.isComplete).length === 0;
    }
    get legacyEvalText() {
        return '';
    }
    set legacyEvalText(t) { }
}
__decorate([
    override
], MultiSelectScore.prototype, "maxPoints", null);
__decorate([
    override
], MultiSelectScore.prototype, "reachedPoints", null);
__decorate([
    override
], MultiSelectScore.prototype, "progressiveReachablePoints", null);
__decorate([
    override
], MultiSelectScore.prototype, "shouldSetCompletedTimestamp", null);
